export const IATACityLanguageMap: Record<string, string> =
{
    "PVG": "zh",
    "LHW": "zh",
    "INC": "zh",
    "TAO": "zh",
    "TNA": "zh",
    "HKG": "zh",
    "XIY": "zh",
    "DLC": "zh",
    "XNN": "zh",
    "TFU": "zh",
    "NGB": "zh",
    "TYN": "zh",
    "KWL": "zh",
    "JJN": "zh",
    "CKG": "zh",
    "CSX": "zh",
    "TNN": "zh",
    "HHA": "zh",
    "WUX": "zh",
    "KWE": "zh",
    "WNZ": "zh",
    "LJG": "zh",
    "YTY": "zh",
    "PKX": "zh",
    "BJS": "zh",
    "SHA": "zh",
    "SWA": "zh",
    "TPE": "zh",
    "XMN": "zh",
    "KHH": "zh",
    "KMG": "zh",
    "MFM": "zh",
    "PEK": "zh",
    "CAN": "zh",
    "TSA": "zh",
    "URC": "zh",
    "ZHA": "zh",
    "SYX": "zh",
    "CTU": "zh",
    "HRB": "zh",
    "SZX": "zh",
    "SHE": "zh",
    "HAK": "zh",
    "CGO": "zh",
    "NKG": "zh",
    "FOC": "zh",
    "ZGC": "zh",
    "MMC": "zh",
    "NNG": "zh",
    "HGH": "zh",
    "TSN": "zh",
    "WUH": "zh",
    "DSN": "zh",
    "DYG": "zh",
    "DLU": "zh",
    "CA": "zh"
};